import Login from "src/components/feature/Login";

const AdminLogin = () => {
  return <Login />;
};

export default AdminLogin;
